import { emitSignal as emitSignalService } from '@/gql/services/payroll.service';
import bam from '@/lib/bam';

interface EmitEventParams {
  event: string;
  company?: string;
  userId?: string;
  properties?: Record<string, any>;
}

/**
 * Utility function to emit events with error handling
 * @param eventName The name of the event to emit
 * @param properties The properties to include with the event
 */
export const emitEvent = async (
  eventName: string,
  properties: Record<string, any> = {}
) => {
  try {
    emitSignalService({
      event: eventName,
      ...properties,
    });
  } catch (error) {
    bam.trackEvent('SIGNAL_EMIT_FAILED', error);
  }
};

/**
 * Legacy function for backward compatibility
 * @param params The event parameters including event name and properties
 */
export const emitSignal = (params: EmitEventParams) => {
  try {
    emitSignalService(params);
  } catch (error) {
    bam.trackEvent('SIGNAL_EMIT_FAILED', error);
  }
};
